import React, {ReactNode} from "react";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import {Button, Menu} from "@mui/material";

export function SpecialMenu(props: {
  children?: ReactNode
}) {
  const [specialMenuAnchorEl, setSpecialMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const specialMenuOpen = Boolean(specialMenuAnchorEl);

  const handleSpecialMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setSpecialMenuAnchorEl(event.currentTarget);
  };

  const handleSpecialMenuClose = () => {
    setSpecialMenuAnchorEl(null);
  };

  return (
    <>
      <Button variant={"outlined"} onClick={handleSpecialMenuOpen}>
        <MoreHorizIcon color="action" />
      </Button>
      <Menu
        id="special-menu"
        anchorEl={specialMenuAnchorEl}
        keepMounted
        open={specialMenuOpen}
        onClose={handleSpecialMenuClose}
      >
        <div onClick={() => handleSpecialMenuClose()}>
          {props.children}
        </div>
      </Menu>
    </>
  )
}
